import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Strip the host from a server-generated manageUrl so it always resolves locally.
 *  The server builds manageUrl with getEmailBaseUrl() (production domain) for
 *  use in emails. Dashboard links must use only the pathname or they navigate
 *  to production when running in dev. */
export function manageActionPath(url: string | null | undefined): string | null {
  if (!url) return null;
  try { return new URL(url).pathname; } catch { return url; }
}

export function generateTimeSlots(startHour: number, endHour: number, intervalMinutes: number = 30): string[] {
  const validInterval = [15, 30, 60].includes(intervalMinutes) ? intervalMinutes : 30;
  const slots: string[] = [];
  for (let totalMinutes = startHour * 60; totalMinutes < endHour * 60; totalMinutes += validInterval) {
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    const ampm = h < 12 ? "AM" : "PM";
    const mm = m === 0 ? "00" : String(m).padStart(2, "0");
    slots.push(`${hour12}:${mm} ${ampm}`);
  }
  return slots;
}
